<template>
  <v-container>
    <v-row dense class="text-center">
      <v-col cols="12">
        <v-container>
          <v-row>
            <v-col cols="1">
              <v-btn icon @click="$router.go(-1)">
                <v-icon color="blue">
                  mdi-arrow-left
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row justify="center">
            <v-col class="text-left text-caption grey-text" cols="11">
              <div v-if="currentCourse !== null">
                {{ currentCourse.courseName }} > {{ currentUnit.unitTitle }} > {{ currentLesson.lessonTitle }}
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row justify="center">
            <v-col v-if="$vuetify.breakpoint.width > 1024" cols="12">
              <iframe
                width="896"
                height="504"
                :src="currentLesson.videoUrlRef"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </v-col>
            <v-col v-if="$vuetify.breakpoint.width <= 1024 && $vuetify.breakpoint.width > 800" cols="12">
              <iframe
                width="640"
                height="360"
                :src="currentLesson.videoUrlRef"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </v-col>
            <v-col v-if="$vuetify.breakpoint.width <= 800 && $vuetify.breakpoint.width > 550" cols="12">
              <iframe
                width="480"
                height="270"
                :src="currentLesson.videoUrlRef"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </v-col>
            <v-col v-if="$vuetify.breakpoint.width <= 550" cols="12">
              <iframe
                width="256"
                height="144"
                :src="currentLesson.videoUrlRef"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row v-if="currentLesson.notice !== null" justify="center">
            <v-col v-if="$vuetify.breakpoint.width > 500" cols="10">
              <v-subheader>
                補足
              </v-subheader>
              <v-divider />
            </v-col>
            <v-col v-if="$vuetify.breakpoint.width <= 500" cols="12">
              <v-subheader>
                補足
              </v-subheader>
              <v-divider />
            </v-col>
            <v-col v-if="$vuetify.breakpoint.width > 500" cols="9" class="u-pre-wrap text-caption text-left" v-text="currentLesson.notice" />
            <v-col v-if="$vuetify.breakpoint.width <= 500" cols="12" class="u-pre-wrap text-caption text-left" v-text="currentLesson.notice" />
          </v-row>
          <v-row>
            <v-col v-for="(courseMaterialRef, index) in currentLesson.courseMaterialRef" :key="index">
              <div class="text-caption" v-text="courseMaterialRef" />
              <v-btn
                class="ma-2"
                outlined
                :href="require('@/assets/courseMaterials/' + $route.params['courseId']+ '/' + courseMaterialRef)"
                :download="courseMaterialRef"
              >
                講義資料のダウンロード
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Lesson',

  data: function () {
    return {
      units: require(`@/assets/courseData/courseUnits/${this.$route.params.courseId}.json`),
      lessons: require(`@/assets/courseData/courseSections/${this.$route.params.courseId}/unit${this.$route.params.unitId}.json`),
      currentUnit: null,
      currentCourse: null
    }
  },
  computed: {
    ...mapState(['currentLesson'])
  },
  created () {
    if (process.client) {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  },
  mounted () {
    const courseId = this.$route.params.courseId
    const courseData = require('@/assets/courseData/courseCards.json')
    this.currentUnit = this.units.find((unit) => unit.systemUnitNumber === parseInt(this.$route.params.unitId))
    this.currentCourse = courseData.find((course) => course.systemName === courseId)
  },
  methods: {
    handleResize () {
      this.height = window.innerHeight
    }
  }
}
</script>

<style scoped>
.u-pre-wrap {
  white-space: pre-wrap;
}
</style>
